import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {ConfirmDialogProps} from './types';

// ----------------------------------------------------------------------

export default function ConfirmLMSDialog({
  title,
  content,
  action,
  open,
  onClose,
  onCancel,
  onTouchCancel,
  ...other
}: ConfirmDialogProps) {
  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      {...other}>
      <DialogTitle
        sx={{
          pb: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
        {title}
        <IconButton edge="end" onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {content && (
        <DialogContent sx={{typography: 'body2'}}> {content} </DialogContent>
      )}

      <DialogActions>
        {action}

        <Button variant="outlined" color="inherit" onClick={onClose}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}
